import React from 'react';
import { VCredit } from '../keno/VCredit';
import { TipSender } from './TipSender';
import { TipToastFrame } from './TipToastFrame';

export const TipReceivedToast = ({ notice, dismiss }) => <TipToastFrame id={notice.id} direction="received" dismiss={dismiss} testOnly={notice.test_only}>
  <span className="tip-received-label" data-testid={`tip-toast-heading-${notice.id}`}>Tip received</span><TipSender notice={notice} prefix="tip-toast" /><span className="tip-received-verb" data-testid={`tip-toast-action-${notice.id}`}>tipped you</span><VCredit minor={notice.amount_minor} testid={`tip-toast-amount-${notice.id}`} />
</TipToastFrame>;